/** Format an ISO date string into a readable locale string. */
export const formatDate = (dateString) => {
  if (!dateString) return "--";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "--";
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

/** Format a currency amount (Nigerian Naira, 2dp). */
export function formatAmountForDisplay(amount) {
  if (typeof amount === "string") amount = parseFloat(amount);
  if (Number.isNaN(amount)) return "0.00";
  return amount.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Payment status → badge class. */
export const paymentStatusBadgeClass = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "SUCCESS":
    case "COMPLETED":
    case "PAID":
      return "badge bg-success";
    case "PENDING":
    case "PENDING_PAYMENT":
    case "PENDING_PAYMENT_METHOD":
      return "badge bg-warning text-dark";
    case "FAILED":
      return "badge bg-danger";
    default:
      return "badge bg-secondary";
  }
};

/** Fulfillment status → badge class. */
export const fulfillmentStatusBadgeClass = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "FULFILLED":
      return "badge bg-success";
    case "PENDING_FULFILLMENT":
    case "PENDING":
    case "PROCESSING":
      return "badge bg-info";
    case "FAILED_FULFILLMENT":
    case "FAILED":
      return "badge bg-danger";
    case "INVENTORY_EXHAUSTED":
      return "badge bg-dark";
    default:
      return "badge bg-secondary";
  }
};

/** Email delivery status → badge class. */
export const emailStatusBadgeClass = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "SENT":
    case "DELIVERED":
      return "badge bg-success";
    case "PENDING":
    case "RETRYING":
      return "badge bg-warning text-dark";
    case "FAILED":
      return "badge bg-danger";
    default:
      return "badge bg-secondary";
  }
};

/** Severity → badge class used for dashboard alerts. */
export const severityBadgeClass = (severity) => {
  switch (String(severity || "").toUpperCase()) {
    case "CRITICAL":
    case "ERROR":
      return "badge bg-danger";
    case "WARNING":
      return "badge bg-warning text-dark";
    case "INFO":
      return "badge bg-info";
    case "SUCCESS":
      return "badge bg-success";
    default:
      return "badge bg-secondary";
  }
};

/** Normalize variants of a payment/fulfillment/email status. */
export const normalizeStatus = (value) => {
  const s = String(value || "").toUpperCase().replace(/\s+/g, "_");
  if (["PENDING_PAYMENT_METHOD", "PENDING_PAYMENT"].includes(s) || s === "PENDING") {
    return "PENDING";
  }
  if (["PAID", "COMPLETED", "SUCCESSFUL", "SUCCESS"].includes(s)) return "COMPLETED";
  return s;
};

/** Payment/fulfillment/email status option lists for the filter dropdowns. */
export const PAYMENT_STATUS_OPTIONS = ["COMPLETED", "PENDING", "FAILED", "ABANDONED"];
export const FULFILLMENT_STATUS_OPTIONS = [
  "FULFILLED",
  "INVENTORY_SHORTAGE",
  "PENDING_PAYMENT",
  "NOT_FULFILLED",
];
export const EMAIL_STATUS_OPTIONS = ["SENT", "FAILED", "QUEUED"];
export const EXAM_TYPE_OPTIONS = ["WAEC", "NECO", "NABTEB"];
export const SORT_OPTIONS = [
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
  { value: "amount", label: "Amount (High-Low)" },
  { value: "-amount", label: "Amount (Low-High)" },
];